/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { DrawerBodyProps } from './types';

const Body = ({
  children,
  paddingLeft = true,
  paddingRight = true
}: DrawerBodyProps) => {
  return (
    <div
      className={`clientos-ui-toolkit-drawer__body${paddingLeft && ' clientos-ui-toolkit-drawer__body--padding-left'}${paddingRight && ' clientos-ui-toolkit-drawer__body--padding-right'}`}
    >
      {children}
    </div>
  );
};

export default Body;
